import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { Home } from '@/features/home'

const homeSearchSchema = z
  .object({
    language: z.string().optional(),
    tab: z.string().optional(),
  })
  .catch({})

export const Route = createFileRoute('/_authenticated/new-vehicle/customers/')({
  validateSearch: homeSearchSchema,
  beforeLoad: ({ search }) => {
    if (!search?.language) {
      throw redirect({
        to: '/new-vehicle/customers',
        search: {
          language: 'en',
          tab: search?.tab || 'member',
        },
      })
    }
  },
  component: Home,
})
